import React from 'react';
import {Helmet} from "react-helmet";
import { Box, Container, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, Typography, useTheme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const SteelInfoPage: React.FC = () => {

  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Steel Scrap Information - Scrap E-Auction Online Scrap Metal Auction Platform</title>
        <meta name="description" content="Scrap market information and rates" />
      </Helmet>
      <Box sx={{ backgroundColor: '#fbf9fa'}}>
        <Container sx={{ py: 4, bgcolor: '#fbf9fa' }}>
          <Stack gap={5} direction="column">
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Typography variant="h1" gutterBottom sx={{ fontWeight: '600' }}>
                Steel Info & Rates
              </Typography>
            </Box>
            <Paper sx={{ p: 4 }}>
              <Stack gap={5} direction="column">
                <Typography variant="body1" component="p">
                  <Typography component="span" color='primary'>Scrap e-Auction</Typography> is pioneered in the field of 
                  online auction. We develop e-Business for clients to get higher realization through the model of 
                  forward e-Auction on website www.steeleauction.com for scrap disposal and tendering.
                </Typography>
                <Typography variant="body1" component="p">
                  <Typography component="span" color='primary'>Scrap e-Auction</Typography> is the best place to get 
                  exact information of Scrap at the existing prices in the market. Join us now through easy subscription 
                  facility and avail membership benefits.
                </Typography>
                <Typography variant="body1" component="p">
                  <Typography component="span" color='primary'>Scrap e-Auction</Typography> provides information service for current Scrap Market rates of the following products:
                </Typography>
                <Box sx={{ p: 3, backgroundColor: '#eff6ff', borderRadius: '10px', border: '1px solid #c5deff' }}>
                  <Typography variant="h3" fontWeight={600} color="#1c398e" mb={2}>Our Services</Typography>
                  <List sx={{ listStyleType: "disc", pl: 4 }}>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">MS Steel: </Typography>Scrap, Ingot, Cast Iron, Sponge Iron, TMT</>} />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">Aluminium: </Typography>Rod, Ingot, Wire Scrap, Chadri, Utensils/Bartan, Accessories/Purja</>} />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">Copper Wire: </Typography>Scrap, Wire</>} />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">Brass: </Typography>Accessories/Purja, Chadri, Honey</>} />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">Lead: </Typography>Local Rod, Videshi Rod</>} />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">Gun Metal: </Typography>Local Scrap, Mix Scrap, Jalandhar Scrap</>} />
                    </ListItem>
                    <ListItem sx={{ display: "list-item", py: 0 }}>
                      <ListItemText primary={<><Typography component="span" fontWeight="600">Battery: </Typography>Black base Battery, White base Battery</>} />
                    </ListItem>
                  </List>
                </Box>
                <Box sx={{ p: 3, backgroundColor: '#eff6ff', borderRadius: '10px', border: '1px solid #c5deff' }}>
                  <Typography variant="h3" fontWeight={600} color="#1c398e" mb={2}>Our Services</Typography>
                  <Typography variant="body1" component="p">
                    We believe information is the key for business organizations to have an edge over competition. 
                    We acknowledge the importance of accurate and timely data. We have created a wide platform for 
                    buyers and sellers of Scrap across the country and act as a strong link between them, making trade easy among them.
                  </Typography>
                </Box>
                <Typography variant="body1" component="p">
                  Our mission is to build the largest network of people related to Scrap at all levels; 
                  to build a platform where we organize the Scrap information and make it accessible and most 
                  useful to our customers and associates.
                </Typography>
                <Box sx={{ p: 3, backgroundColor: '#f0fdf4', borderRadius: '10px', border: '1px solid #b9f8cf' }}>
                  <Typography variant="h3" fontWeight={600} color="#0d542b" mb={2}>Key Benefits</Typography>
                  <List sx={{ listStyleType: "disc", pl: 0 }}>
                    <ListItem sx={{ py: 0, gap: 1.5 }}>
                      <ListItemIcon sx={{ minWidth: 'auto' }}><CheckIcon sx={{ fontSize: 25, color: theme.palette.primary.main }} /></ListItemIcon>
                      <ListItemText primary="Real-time market rate information" />
                    </ListItem>
                    <ListItem sx={{ py: 0, gap: 1.5 }}>
                      <ListItemIcon sx={{ minWidth: 'auto' }}><CheckIcon sx={{ fontSize: 25, color: theme.palette.primary.main }} /></ListItemIcon>
                      <ListItemText primary="Nationwide network of buyers and sellers" />
                    </ListItem>
                    <ListItem sx={{ py: 0, gap: 1.5 }}>
                      <ListItemIcon sx={{ minWidth: 'auto' }}><CheckIcon sx={{ fontSize: 25, color: theme.palette.primary.main }} /></ListItemIcon>
                      <ListItemText primary="Transparent auction process" />
                    </ListItem>
                    <ListItem sx={{ py: 0, gap: 1.5 }}>
                      <ListItemIcon sx={{ minWidth: 'auto' }}><CheckIcon sx={{ fontSize: 25, color: theme.palette.primary.main }} /></ListItemIcon>
                      <ListItemText primary="Verified participants" />
                    </ListItem>
                    <ListItem sx={{ py: 0, gap: 1.5 }}>
                      <ListItemIcon sx={{ minWidth: 'auto' }}><CheckIcon sx={{ fontSize: 25, color: theme.palette.primary.main }} /></ListItemIcon>
                      <ListItemText primary="Easy subscription and membership" />
                    </ListItem>
                  </List>
                </Box>
              </Stack>
            </Paper>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default SteelInfoPage;
